import {
  NavButtonsSidebarSkeleton,
  NavSidebarButton,
  NavSidebarSection,
  NavSidebarStatusButton,
} from '@insurancemenu/imenu-components-lib';
import { AssignmentInd } from '@insurancemenu/imenu-components-lib/dist/icons';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { RouteV2Id } from 'routes/routesConfigV2';
import { redirectToRoute } from 'routes/redirectToRoute';
import { QuoteFlowSidebarDelegate } from 'store/flows/quote/sidebarDelegate';
import { GROUP_PROFILE_BTN_TEST_ID } from 'components/common/enrollment/constants';
import InviteEmployerSection from 'components/common/group/InviteEmployerSection';
import { zywaveUserRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { useRootStore } from 'store/rootStore';
import { CHECKLIST_STEPS_SECTION_TEST_ID, CHECKLIST_STEPS_SKELETON_TEST_ID } from '../../constants';

interface QuoteFlowSidebarProps {
  sidebarDelegate: QuoteFlowSidebarDelegate;
  pageId: RouteV2Id;
}

const QuoteSidebar: React.FC<QuoteFlowSidebarProps> = observer(({ sidebarDelegate, pageId }) => {
  const { userStore } = useRootStore();
  const { groupId, checklistSteps, isFlowDataLoading } = sidebarDelegate;

  const onRedirectClick = (): void => {
    redirectToRoute(RouteV2Id.GROUP_HUB, { groupId });
  };

  const showInviteEmployerSection = !zywaveUserRights(userStore.userRoles);

  return (
    <>
      <NavSidebarSection label="Group">
        <NavSidebarButton
          leftIconProp={AssignmentInd}
          onClick={onRedirectClick}
          data-test-id={GROUP_PROFILE_BTN_TEST_ID}
        >
          Group Profile
        </NavSidebarButton>
        {showInviteEmployerSection && (
          <InviteEmployerSection inviteEmployersDelegate={sidebarDelegate.inviteEmployersDelegate} />
        )}
      </NavSidebarSection>
      {isFlowDataLoading ? (
        <NavButtonsSidebarSkeleton data-test-id={CHECKLIST_STEPS_SKELETON_TEST_ID} />
      ) : (
        <NavSidebarSection label="Checklist Steps" data-test-id={CHECKLIST_STEPS_SECTION_TEST_ID}>
          {checklistSteps.map((step) => (
            <NavSidebarStatusButton
              key={step.pageId}
              completionStatus={step.completionStatus}
              isActive={step.pageId === pageId}
              onClick={() => {
                if (step.pageId !== pageId) {
                  step.onClick();
                }
              }}
            >
              {step.label}
            </NavSidebarStatusButton>
          ))}
        </NavSidebarSection>
      )}
    </>
  );
});

export default QuoteSidebar;
